import React, { Component, PropTypes } from 'react';
import { Colors, Units } from 'Css';
import classNames from 'classnames';
import { connect } from 'Util/refluxConnector';
import { AppStateActions, AppStateStore } from 'entities/AppState';
import MainMenu from 'components/Material/MainMenu';
import { history } from 'helpers';

const css = oxygenCss({
  root: {
    position: 'relative',
    backgroundColor: Colors.theme.Light.background,
    boxSizing: 'border-box',
    zIndex: 1,
    '&dense': {
      paddingTop: Units.keyline
    },
    '&hasHeader': {
      paddingTop: Units.keyline,
      '&dense': {
        paddingTop: Units.keyline
      }
    }
  }
});

class AppPage extends Component {
  state = {
    dense: false
  };

  static propTypes = {
    children: PropTypes.node,
    header: PropTypes.node,
    dense: PropTypes.bool
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = event => {
    const { scrollTop } = document.body;
    const { dense } = this.state;
    if (!dense && scrollTop > Units.keyline * 2) {
      this.setState({ dense: true });
    } else if (dense && scrollTop <= Units.keyline * 2) {
      this.setState({ dense: false });
    }
  };

  onMenuChange = (event, key, payload) => {
    if (payload.route) {
      history.push(`/${payload.route}`);
    } else if (payload.action && this[payload.action]) {
      this[payload.action](payload);
      event.preventDefault();
    }
  };

  render() {
    const {
      header,
      children,
      mainMenuOpen,
      openMainMenu,
      closeMainMenu
    } = this.props;

    const dense = this.props.dense || this.state.dense;
    const classes = classNames(css.root, {
      [css.hasHeader]: !!header,
      [css.dense]: dense
    });
    if (header) {
      return (
        <div className={classes}>
          <MainMenu
            onRequestClose={closeMainMenu}
            zIndex={101}
            initialOpen={mainMenuOpen}
            onChange={this.onMenuChange}
          />
          {React.cloneElement(header, {
            dense
          })}
          {children}
        </div>
      );
    } else {
      return (
        <div className={classes}>
          <MainMenu
            onRequestClose={closeMainMenu}
            zIndex={101}
            initialOpen={mainMenuOpen}
            onChange={this.onMenuChange}
          />
          {children}
        </div>
      );
    }
  }
}

export default connect(
  [
    [
      AppStateStore,
      state => ({
        mainMenuOpen: state.mainMenuOpen
      })
    ]
  ],
  {
    openMainMenu: AppStateActions.openMainMenu,
    closeMainMenu: AppStateActions.closeMainMenu
  }
)(AppPage);



// WEBPACK FOOTER //
// ./src/js/Cio/AppPage.js